<template>
    <div>
        <v-row class="px-2 pt-2">
            <!-- From Date -->
            <v-col md="2" class="py-1">
                <v-menu
                    v-model="fromDateModal"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                ><template v-slot:activator="{ on }">
                    <v-text-field
                        v-model="search.fromDate"
                        label="From Date"
                        append-icon="mdi-calendar"
                        readonly
                        v-on="on"
                        class="mt-0 pt-0"
                    ></v-text-field
                ></template>
                    <v-date-picker
                        v-model="search.fromDate"
                        @input="fromDateModal = false"
                        @click:date="handleDateFilters"
                    ></v-date-picker>
                </v-menu>
            </v-col>

            <!-- To Date -->
            <v-col md="2" class="py-1">
                <v-menu
                    v-model="toDateModal"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                ><template v-slot:activator="{ on }">
                    <v-text-field
                        v-model="search.toDate"
                        label="To Date"
                        append-icon="mdi-calendar"
                        readonly
                        v-on="on"
                        class="mt-0 pt-0"
                    ></v-text-field
                ></template>
                    <v-date-picker
                        v-model="search.toDate"
                        @input="toDateModal = false"
                        @click:date="handleDateFilters"
                    ></v-date-picker>
                </v-menu>
            </v-col>
        </v-row>

        <v-row class="px-4">
            <v-col md="12" class="pa-2">
                <v-data-table
                    v-if="report"
                    :headers="headers"
                    :items="report"
                    :items-per-page="10"
                    class="elevation-0"
                >
                    <template v-slot:item.value="{ item }">
                        {{ new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(item.value) }}<br>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>

        <v-overlay :value="loading">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    data() {
        return {
            report: null,
            fromDateModal: false,
            toDateModal: false,
            loading: false,
            search: { fromDate: new Date().toISOString().substr(0, 10),
                      toDate: new Date().toISOString().substr(0, 10) },
            headers: [{ text: 'Country', value: 'country', sortable: true, align: 'left' },
                      { text: 'Country Code', value: 'code', sortable: false, align: 'left' },
                      { text: 'Revenue', value: 'value', sortable: true, align: 'left' },
                      { text: 'Num of Transactions', value: 'volume', sortable: true, align: 'left' }]
        }
    },
    beforeMount() {
        this.loading = true;
        this.getReport();
    },
    methods: {
        getReport() {
            axios({
            method: 'post',
            url: 'earth2-revenue-by-country',
            data: { search: this.search },
            config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
            })
            .then(response => {
                this.report = response.data;
                this.loading = false;
            })
            .catch(e => {
                this.errors.push(e)
            })
        },
        handleDateFilters() {
            if(this.search.toDate < this.search.fromDate) {
                this.search.fromDate = this.search.toDate;
            }
            this.loading = true;
            this.getReport();
        }
    }
}
</script>